import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

const BcvContext = createContext({ rate: null, isLoading: true, refresh: () => {} });

export const BcvProvider = ({ children }) => {
  const [rate, setRate] = useState(null);
  const [updatedAt, setUpdatedAt] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const fetchRate = useCallback(async () => {
    try {
      const res = await fetch(`${BACKEND_URL}/api/bcv-rate`);
      if (res.ok) {
        const data = await res.json();
        setRate(data.rate);
        setUpdatedAt(data.updated_at);
      }
    } catch (e) {
      console.error('BCV rate fetch failed', e);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchRate();
    const interval = setInterval(fetchRate, 30 * 60 * 1000);
    return () => clearInterval(interval);
  }, [fetchRate]);

  const toBolivares = (usd) => {
    if (!rate || !usd) return null;
    return usd * rate;
  };

  return (
    <BcvContext.Provider value={{ rate, updatedAt, isLoading, refresh: fetchRate, toBolivares }}>
      {children}
    </BcvContext.Provider>
  );
};

export const useBcv = () => useContext(BcvContext);
